import { render } from "./multiplexer.vue?vue&type=template&id=532d88ea&scoped=true"
import script from "./multiplexer.vue?vue&type=script&lang=js"
export * from "./multiplexer.vue?vue&type=script&lang=js"

import "./multiplexer.vue?vue&type=style&index=0&id=532d88ea&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532d88ea"]])

export default __exports__